import React, { useState } from "react";
import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import ClientReceiptEntryForm from "./form";
import { ClientReceiptColumns } from "../../../data/DynamicTable/Collumns";
import { accountsmanagement } from "../../../config";
import { allReceiptsView } from "../../../data/Axios/queries";
import ClientReceiptDetailDialog from "./ClientReceiptDetailDialog";

const base_url = accountsmanagement.uri;

function ClientReceiptList() {
    const [openReceiptDialog, setOpenReceiptDialog] = useState(false);
    const [selectedReceipt, setSelectedReceipt] = useState(null);
    const [refreshTable, setRefreshTable] = useState(null);

    // Configuration object
    const actions = {
        entity: "Client Receipts",
        edit: {
            key: "EDIT",
            button_name: "Edit",
            Show_Button: true,
            permission: "EditPermission",
            disableCondition: (row) => {
                return row.statusId === 3 ||
                    row.statusDescription === "Approved" ||
                    row.status === "Approved" ||
                    row.isPosted === true ||
                    row.isPosted === 1;
            }
        },
        add: {
            key: "ADD",
            button_name: "Add",
            Show_Button: true,
            permission: "CreatePermission",
        },
        approveClientReceipt: {
            key: "APPROVERECEIPT",
            button_name: "Approve",
            Show_Button: true,
            permission: "hasNoPermission",
            roleGroupId: [1, 2, 3, 4],
        },
        ViewClientReceiptLines: {
            key: "VIEWRECEIPTLINES",
            button_name: "Receipt Lines",
            Show_Button: true,
            permission: "hasNoPermission",
            roleGroupId: [1, 2, 3, 4],
            showStatus: true,
            onClick: (row, refresh) => {
                setRefreshTable(() => refresh);
                setSelectedReceipt(row);
                setOpenReceiptDialog(true);
            },
        },
        PrintReceipt: {
            key: "PRINTRECEIPT",
            button_name: "Print",
            Show_Button: true,
            permission: "hasNoPermission",
            roleGroupId: [1, 2, 3, 4],
        },
        activateDeactivate: {
            key: "ACTIVATEDEACTIVATE",
            button_name: "Deactivate",
            Show_Button: true,
            permission: "ActivatePermission",
            modelName: "id",
            inputObjectName: "activateDeactivateReceipts",
            required: "id"
        },
    };

    return (
        <Box m="10px">
            <DynamicTable
                title="Client Receipts"
                subtitle="Client Receipts List - View, create, edit or manage receipts"
                columns={ClientReceiptColumns}
                FormComponent={ClientReceiptEntryForm}
                query={allReceiptsView}
                base_url={base_url}
                actions={actions}
            />

            {openReceiptDialog && (
                <ClientReceiptDetailDialog
                    open={openReceiptDialog}
                    onClose={() => {
                        setOpenReceiptDialog(false);
                        if (refreshTable) refreshTable();
                    }}
                    receiptData={selectedReceipt}
                    refetchData={() => {
                        if (refreshTable) refreshTable();
                    }}
                />
            )}
        </Box>
    );
}

export default ClientReceiptList;
